<!-- @format -->

<template>
  <div>
    <sui-modal v-model="showDisclaimer">
      <sui-modal-header>Projection Methodology & Assumptions</sui-modal-header>
      <sui-modal-content style="height: 500px">
        <Disclaimer
          :moreLikelyZScore="moreLikelyZScore"
          :lessLikelyZScore="lessLikelyZScore"
          :isFundAlphaEqualToFees="isFundAlphaEqualToFees"
          :partnerCapitalMarketAssumptions="partnerCapitalMarketAssumptions"
        />
      </sui-modal-content>
      <sui-modal-actions>
        <sui-button @click.native="showDisclaimer = false">Close</sui-button>
      </sui-modal-actions>
    </sui-modal>
    <div class="projection-container">
      <div
        class="proj"
        :style="
          'background: url(' +
            partnerBackgroundUrl +
            ') center center; background-size: cover;'
        "
      ></div>
      <div class="proj-menu"></div>

      <div class="ui sixteen column padded grid centered">
        <div class="row">
          <div class="fifteen wide column">
            <div class="ui divided items">
              <div class="ui item">
                <div
                  :class="
                    'ui tiny image animated rotate-vert-center ' + 'delay-1'
                  "
                >
                  <img :src="goalPictureUrl" />
                </div>
                <div class="content">
                  <h2>{{ goalName }}</h2>
                  <div class="ui description">
                    allocated to
                    <strong>{{
                      projectionRequest.accounts[0].portfolios[0].portfolio
                        .portfolioName
                    }}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="four wide column">
            <div class="ui small secondary pointing menu">
              <a
                class="item"
                v-bind:class="{ active: tabLeft == 6 }"
                @click.prevent="tabLeft = 6"
                >Goal</a
              >
              <a
                class="item"
                v-if="wrapperType"
                v-bind:class="{ active: tabLeft == 21 }"
                @click.prevent="tabLeft = 21"
                >FNA</a
              >
              <a
                class="item"
                v-if="wrapperType == '' || !wrapperType"
                v-bind:class="{ active: tabLeft == 2 }"
                @click.prevent="tabLeft = 2"
                >Contrib.</a
              >
              <a
                class="item"
                v-if="wrapperType == '' || !wrapperType"
                v-bind:class="{ active: tabLeft == 3 }"
                @click.prevent="tabLeft = 3"
                >Inc.</a
              >
              <a
                class="item"
                v-bind:class="{ active: tabLeft == 4 }"
                @click.prevent="tabLeft = 4"
              >
                <i
                  style="color: red"
                  class="ui warning icon"
                  v-if="
                    selectedPortfolio.riskProfile.id !=
                      goalRiskProfile.getGoalRiskProfileResponse
                        .riskProfileObject.id
                  "
                >
                </i>
                Portf.</a
              >
              <a
                class="item"
                v-bind:class="{ active: tabLeft == 7 }"
                @click.prevent="tabLeft = 7"
                ><i class="ui settings icon"></i
              ></a>
              <a
                class="item"
                v-bind:class="{ active: tabLeft == 8 }"
                @click.prevent="tabLeft = 8"
                ><i class="ui tint icon"></i
              ></a>
            </div>
          </div>
          <div class="eleven wide column">
            <div class="ui small secondary pointing menu">
              <a
                v-if="debug"
                class="item"
                v-bind:class="{ active: tabRight == 1 }"
                @click.prevent="tabRight = 1"
                >Debug Request Response</a
              >

              <a
                v-if="debug"
                class="item"
                v-bind:class="{ active: tabRight == 2 }"
                @click.prevent="tabRight = 2"
                >Debug Accounts</a
              >
              <a
                v-if="debug"
                class="item"
                v-bind:class="{ active: tabRight == 3 }"
                @click.prevent="tabRight = 3"
                >Debug Income</a
              >
              <a
                class="item"
                v-bind:class="{ active: tabRight == 9 }"
                @click.prevent="tabRight = 9"
                ><span
                  v-if="
                    goalRiskProfile.getGoalRiskProfileResponse.greenYellowRed ==
                      0
                  "
                >
                  <i class="ui icon circle" style="color: green"></i>
                </span>
                <span
                  v-if="
                    goalRiskProfile.getGoalRiskProfileResponse.greenYellowRed ==
                      1
                  "
                >
                  <i class="ui icon circle" style="color: orange"></i>
                </span>
                <span
                  v-if="
                    goalRiskProfile.getGoalRiskProfileResponse.greenYellowRed ==
                      2
                  "
                >
                  <i class="ui icon circle" style="color: red"></i>
                </span>
                Risk Profile</a
              >
              <a
                class="item"
                v-if="wrapperType == 'RetirementAnnuity'"
                v-bind:class="{ active: tabRight == 21 }"
                @click.prevent="tabRight = 21"
                >Summary</a
              >
              <a
                class="item"
                v-bind:class="{ active: tabRight == 4 }"
                @click.prevent="tabRight = 4"
                ><i v-if="false" class="chart line icon"></i> Projected
                Balances</a
              >

              <a
                class="item"
                v-bind:class="{ active: tabRight == 5 }"
                @click.prevent="tabRight = 5"
                ><i v-if="false" class="chart line icon"></i> Projected
                Income</a
              >
              <a
                class="item"
                v-if="showCashflowTable"
                v-bind:class="{ active: tabRight == 7 }"
                @click.prevent="tabRight = 7"
                ><i class="table icon"></i> CF Table</a
              >
              <a
                class="item"
                v-bind:class="{ active: tabRight == 8 }"
                @click.prevent="tabRight = 8"
                ><i v-if="false" class="info icon"></i> Portfolio
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="">
      <div class="">
        <div class="">
          <div class="ui sixteen column padded grid centered">
            <div class="row">
              <div class="four wide column">
                <div v-show="tabLeft == 1">
                  <div class="ui segment">
                    <div class="ui attached message">
                      <div class="content">
                        <div class="header">Client Details</div>
                      </div>
                    </div>
                    <div class="ui form attached fluid segment">
                      <div class="ui field">
                        <label>First Name</label>
                        <input :disabled="true" v-model="clientFirstName" />
                      </div>
                      <div class="ui field">
                        <label>Last Name</label>
                        <input :disabled="true" v-model="clientLastName" />
                      </div>
                      <div class="ui field">
                        <label>E-Mail</label>
                        <input :disabled="true" v-model="email" />
                      </div>
                      <div class="ui field">
                        <label>Current Age</label>
                        <input v-model="currentAge" @change="ageChange" />
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="tabLeft == 21">
                  <div class="ui attached green segment">
                    <div class="content">
                      <h4>Financial Needs Analysis</h4>
                    </div>
                  </div>

                  <retirement-annuity-inputs-v-3
                    v-if="wrapperType == 'RetirementAnnuity'"
                    :raInputsDto="raInputsDto"
                    @handleWrapperInputsChanged="
                      handleWrapperInputsChanged($event)
                    "
                  />

                  <living-annuity-inputs-v-3
                    v-if="wrapperType == 'LivingAnnuity'"
                    :laInputsDto="laInputsDto"
                    @handleWrapperInputsChanged="
                      handleWrapperInputsChanged($event)
                    "
                  />
                </div>
                <div v-show="tabLeft == 2">
                  <div class="ui attached green segment">
                    <div class="content">
                      <h4>Financial Needs Analysis</h4>
                    </div>
                  </div>

                  <InvestmentLumpsumInputV21
                    :currency="currency"
                    :shortCurrency="shortCurrency"
                    :accounts="accounts"
                    :currentAge="currentAge"
                    :aaType="aaType"
                    @handleInvestmentChanged="handleInvestmentChanged($event)"
                  />
                  <div class="ui divider"></div>
                  <div class="ui attached message">
                    <strong>Recurring Contributions</strong>
                  </div>
                  <div class="ui attached compact segment">
                    <div
                      class="ui"
                      v-for="a in additionalContributions"
                      :key="a.keyIndex"
                    >
                      <sui-accordion>
                        <sui-accordion-title>
                          <sui-icon name="dropdown" />

                          <strong>{{ a.contributionLabel }}</strong>
                          <small> ({{ helpfulContributionLabel(a) }})</small>
                        </sui-accordion-title>
                        <sui-accordion-content>
                          <InvestmentAdditionalInputV21
                            :currency="currency"
                            :shortCurrency="shortCurrency"
                            @removeAdditionalContribution="
                              removeAdditionalContribution($event)
                            "
                            @handleInvestmentChanged="
                              handleInvestmentChanged(a.keyIndex, $event)
                            "
                            @handleContributionLabelChanged="
                              handleContributionLabelChanged(a.keyIndex, $event)
                            "
                            :contributionLabel="a.contributionLabel"
                            :keyIndex="a.keyIndex"
                            :accounts="accounts"
                            :applyContribution="applyContribution"
                            :currentAge="currentAge"
                            :contribution="a.contribution"
                            :contributionFrequency="a.contributionFrequency"
                            :contributionGrowth="a.contributionGrowth"
                            :contributionGrowthFrequency="
                              a.contributionGrowthFrequency
                            "
                            :contributionToLast="a.contributionToLast"
                            :contributionStartYear="a.contributionStartYear"
                            :aaType="aaType"
                        /></sui-accordion-content>
                      </sui-accordion>
                    </div>
                  </div>
                  <div class="ui attached message">
                    <div
                      class="ui small button"
                      @click.prevent="addAdditionalRecurringContribution"
                    >
                      Add Contribution
                    </div>
                  </div>
                </div>
                <div v-show="tabLeft == 3">
                  <div class="ui attached green segment">
                    <div class="content">
                      <h4>Financial Needs Analysis</h4>
                    </div>
                  </div>
                  <div class="ui attached message">
                    <div class="content">
                      <div class="header">Recurring Income</div>
                    </div>
                  </div>
                  <div class="ui attached compact segment">
                    <div
                      class="ui"
                      v-for="a in additionalIncome"
                      :key="a.keyIndex"
                    >
                      <sui-accordion>
                        <sui-accordion-title>
                          <sui-icon name="dropdown" />

                          <strong>{{ a.incomeLabel }}</strong>
                          <small> ({{ helpfulIncomeLabel(a) }})</small>
                        </sui-accordion-title>
                        <sui-accordion-content>
                          <IncomeInputV21
                            :currency="currency"
                            :aaType="aaType"
                            :shortCurrency="shortCurrency"
                            :keyIndex="a.keyIndex"
                            @removeAdditionalIncome="
                              removeAdditionalIncome($event)
                            "
                            @handleIncomeChanged="
                              handleIncomeChanged(a.keyIndex, $event)
                            "
                            @handleIncomeLabelChanged="
                              handleIncomeLabelChanged(a.keyIndex, $event)
                            "
                            :currentAge="currentAge"
                            :incomeLabel="a.incomeLabel"
                            :income="a.income"
                            :taxRate="a.taxRate"
                            :incomeGrowth="a.incomeGrowth"
                            :incomeGrowthFrequency="a.incomeGrowthFrequency"
                            :payoutFrequency="a.payoutFrequency"
                            :incomeToLast="a.incomeToLast"
                            :startYear="a.startYear"
                            :accounts="accounts"
                            :withdrawalStrategy="a.withdrawalStrategy"
                        /></sui-accordion-content>
                      </sui-accordion>
                    </div>
                  </div>
                  <div class="ui attached message">
                    <div
                      class="ui small button"
                      @click.prevent="addAdditionalRecurringIncome"
                    >
                      Add Recurring
                    </div>
                  </div>
                  <br />

                  <IncomeInputAdhocV21
                    @handleAdhocIncomeChanged="handleAdhocIncomeChanged($event)"
                    :currency="currency"
                    :aaType="aaType"
                    :shortCurrency="shortCurrency"
                    :currentAge="currentAge"
                    :hasAdhocCashFlow="adhocInc.hasAdhocCashFlow"
                    :adhocCashFlowAge1="adhocInc.adhocCashFlowAge1"
                    :adhocCashFlow1="adhocInc.adhocCashFlow1"
                    :adhocCashFlowAge2="adhocInc.adhocCashFlowAge2"
                    :adhocCashFlow2="adhocInc.adhocCashFlow2"
                  />
                </div>
                <div v-show="tabLeft == 4">
                  <div class="ui attached green segment">
                    <div class="content">
                      <h4>Suitability</h4>
                    </div>
                  </div>
                  <div class="ui attached compact segment">
                    <RiskInputs
                      :currency="currency"
                      :aaType="aaType"
                      :shortCurrency="shortCurrency"
                      :accounts="accounts"
                      :riskTolerance="riskTolerance"
                      :riskCapacity="riskCapacity"
                      :riskProfile="
                        goalRiskProfile.getGoalRiskProfileResponse
                          .riskProfileObject
                      "
                      :goalRiskProfile="goalRiskProfile"
                      :riskPortfolios="riskPortfolios"
                      :selectedPortfolio="selectedPortfolio"
                      v-on:handleReasonChanged="handleReasonChanged($event)"
                      v-on:handleSelected="riskChange($event)"
                      v-on:updateProjection="updateProjection($event)"
                    />
                  </div>
                </div>
                <div v-show="tabLeft == 5">
                  <FeeInputs
                    :currency="currency"
                    :aaType="aaType"
                    :shortCurrency="shortCurrency"
                    :advisorFee="advisorFee"
                    :otherCharges="otherCharges"
                    :platformFee="platformFee"
                    v-on:handleSelected="feeChange($event)"
                  />
                </div>
                <div v-show="tabLeft == 6">
                  <div class="ui attached green segment">
                    <div class="content">
                      <h4>Financial Needs Analysis</h4>
                    </div>
                  </div>
                  <div class="ui attached segment">
                    <GoalInput
                      :currency="currency"
                      :aaType="aaType"
                      :shortCurrency="shortCurrency"
                      :currentAge="currentAge"
                      :goalName="goalName"
                      :wrapperType="wrapperType"
                      :goalDescription="goalDescription"
                      :goalHasTarget="goalHasTarget"
                      :goalTarget="goalTarget"
                      :goalTargetAge="goalTargetAge"
                      v-on:handleSelected="goalChange($event)"
                      v-on:updateProjection="updateProjection($event)"
                    />
                  </div>
                </div>
                <div v-show="tabLeft == 7">
                  <AdvancedInputsV2
                    :canEdit="false"
                    :currency="currency"
                    :shortCurrency="shortCurrency"
                    :appearanceSettings="appearanceSettings"
                    :moreLikelyZScore="moreLikelyZScore"
                    :lessLikelyZScore="lessLikelyZScore"
                    :showLowestProjectedOutcome="showLowestProjectedOutcome"
                    :isFundAlphaEqualToFees="isFundAlphaEqualToFees"
                    :aaType="aaType"
                    v-on:handleZScoreChanged="handleZScoreChanged($event)"
                  />
                  <div class="ui divider"></div>
                  <FeeInputs
                    :currency="currency"
                    :aaType="aaType"
                    :shortCurrency="shortCurrency"
                    :showAdvisoryFees="showAdvisoryFees"
                    :advisorFee="advisorFee"
                    :otherCharges="otherCharges"
                    :platformFee="platformFee"
                    v-on:handleSelected="feeChange($event)"
                  />
                </div>
                <div v-show="tabLeft == 8">
                  <AppearanceInputsV2
                    :currency="currency"
                    :aaType="aaType"
                    :shortCurrency="shortCurrency"
                    :appearanceSettings="appearanceSettings"
                    v-on:handleZScoreChanged="handleZScoreChanged($event)"
                  />
                </div>
                <div v-if="updated" class="ui segment message">
                  <sui-button
                    v-show="false"
                    @click.prevent="editClick"
                    type="submit"
                    class="primary"
                    >Edit</sui-button
                  >
                  <div is="sui-button-group">
                    <sui-button v-if="id != 0" @click.prevent="cancelClick"
                      >Cancel</sui-button
                    >
                    <sui-button-or v-if="id != 0" />
                    <sui-button
                      :class="loading ? 'loading' : ''"
                      positive
                      @click.prevent="saveClick"
                      >Save</sui-button
                    >
                    <br />
                  </div>
                </div>
                <div class="ui segment message">
                  <router-link
                    class="right floated"
                    :to="'/v2/client/' + clientId"
                    >Back to All Goals</router-link
                  >
                </div>
              </div>
              <div class="eleven wide column">
                <div v-if="tabRight == 1">
                  <div class="ui segment">
                    <input v-model="wrapperType" />
                    <h4>appearance settings</h4>
                    {{ appearanceSettings }}
                    <h4>projectionRequest</h4>
                    {{ projectionRequest.goalRiskProfile }}
                    <h4>projectionRequest</h4>
                    {{ projectionRequest.goalInfo }}
                    <h1>Original Saved Request</h1>
                    <span v-if="originalSavedRequest">{{
                      originalSavedRequest.requestObject
                    }}</span>

                    <h4>Account Asset Allocation</h4>
                    {{ accounts[0].portfolios[0].portfolio.assetAllocation }}
                    <h4>ProjectionRequest</h4>
                    {{ projectionRequest }}
                    <h4>Responses</h4>
                    <h5>1. Total Income Targets</h5>
                    {{ take(projectionResponse.incomeTargetCfs.incomes, 3) }}
                    <h5>2. Total Projections</h5>
                    <table class="ui table">
                      <tr
                        v-for="p in take(projectionResponse.projections, 10)"
                        v-bind:key="p.year"
                      >
                        <td>{{ p.year }}</td>
                        <td>{{ p }}</td>
                      </tr>
                    </table>

                    <h5>3. Account specific projections</h5>
                  </div>
                </div>
                <div v-if="tabRight == 2">
                  <h4>SelectedAccountProjections</h4>
                  {{ selectedAccountProjections }}
                  <h4>Selected</h4>
                </div>
                <div v-if="tabRight == 3">
                  <div class="ui segment">
                    <h4>GetIncomeCashFlowRequest</h4>
                    Debugging income. Selected withdrwawal strategy =
                    {{ getIncomeCashFlowRequestR }}
                    <br />
                    <br />
                    {{ additionalIncome }}

                    <br />

                    <br />
                    <br />

                    <h4>Response</h4>
                  </div>
                </div>
                <div v-if="tabRight == 21">
                  <div class="ui segment">
                    <retirement-annuity-outputs-v-3
                      :loading="loading"
                      :raSummary="projectionResponse.raSummary"
                      :appearanceSettings="appearanceSettings"
                      :clientName="projectionResponse.raSummary.clientName"
                    />
                  </div>
                </div>

                <div v-if="tabRight == 4">
                  <div class="ui segment" :id="colors[1].class">
                    <div class="ui row">
                      <div
                        class="ui sixteen wide column"
                        v-if="projectionRequest && selectedAccountProjections"
                      >
                        <component
                          v-bind:is="currentBalancesTab"
                          :currency="currency"
                          :shortCurrency="shortCurrency"
                          :moreLikelyZScore="moreLikelyZScore"
                          :lessLikelyZScore="lessLikelyZScore"
                          :isFundAlphaEqualToFees="isFundAlphaEqualToFees"
                          :aaType="aaType"
                          :appearanceSettings="appearanceSettings"
                          :colors="colors[1]"
                          :chartProjections="selectedAccountProjections"
                          :projectionRequest="projectionRequest"
                          :applyContribution="applyContribution"
                          :adjustForInflation="adjustForInflation"
                          :highlightRangeDto="highlightRangeDto"
                          :hasAdhocCashFlow="adhocInc.hasAdhocCashFlow"
                          :showLowestProjectedOutcome="
                            showLowestProjectedOutcome
                          "
                          :show="true"
                          v-show="true"
                          :showDisclaimer="showDisclaimer"
                          v-on:handleSelected="handleDisclaimerChanged($event)"
                          v-on:handleInflationChanged="
                            handleInflationChanged($event)
                          "
                          v-on:handleHighlightRangeDtoChanged="
                            handleHighlightRangeDtoChanged($event)
                          "
                        ></component>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="tabRight == 5">
                  <div class="ui segment" :id="colors[1].class">
                    <div class="ui row">
                      <div class="ui sixteen wide column">
                        <component
                          :currency="currency"
                          :shortCurrency="shortCurrency"
                          v-bind:is="currentIncomeTab"
                          :moreLikelyZScore="moreLikelyZScore"
                          :lessLikelyZScore="lessLikelyZScore"
                          :isFundAlphaEqualToFees="isFundAlphaEqualToFees"
                          :aaType="aaType"
                          :appearanceSettings="appearanceSettings"
                          :colors="colors[1]"
                          :chartProjections="selectedAccountProjections"
                          :projectionRequest="projectionRequest"
                          :applyContribution="applyContribution"
                          :adjustForInflation="adjustForInflation"
                          :highlightRangeDto="highlightRangeDto"
                          :currentAge="currentAge"
                          v-on:handleInflationChanged="
                            handleInflationChanged($event)
                          "
                          v-on:handleHighlightRangeDtoChanged="
                            handleHighlightRangeDtoChanged($event)
                          "
                          :show="true"
                          v-show="true"
                        ></component>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="tabRight == 7">
                  <div class="ui segment" :id="colors[1].class">
                    <div class="ui row">
                      <div class="ui sixteen wide column">
                        <component
                          :loading="loading"
                          :currency="currency"
                          :shortCurrency="shortCurrency"
                          v-bind:is="currentIncomeTableTab"
                          :moreLikelyZScore="moreLikelyZScore"
                          :lessLikelyZScore="lessLikelyZScore"
                          :isFundAlphaEqualToFees="isFundAlphaEqualToFees"
                          :aaType="aaType"
                          :appearanceSettings="appearanceSettings"
                          :colors="colors[1]"
                          :chartProjections="selectedAccountProjections"
                          :projectionRequest="projectionRequest"
                          :applyContribution="applyContribution"
                          :adjustForInflation="adjustForInflation"
                          :highlightRangeDto="highlightRangeDto"
                          :currentAge="currentAge"
                          v-on:handleInflationChanged="
                            handleInflationChanged($event)
                          "
                          v-on:handleHighlightRangeDtoChanged="
                            handleHighlightRangeDtoChanged($event)
                          "
                          :show="true"
                          v-show="true"
                        ></component>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="tabRight == 6">
                  <div class="ui segment" :id="style">
                    <div class="ui row">
                      <div class="ui sixteen wide column"></div>
                    </div>
                    <div class="ui row">
                      <div class="ui three wide column">
                        <div>
                          <span class="ui dividing header">Income</span>
                          <div class="ui small statistics">
                            <div class="ui small statistic">
                              <div
                                class="value"
                                v-if="projectionResponse"
                              ></div>
                              <div class="label">Current</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="tabRight == 8">
                  <div class="ui segment" :id="style">
                    <div class="ui">
                      <div class="ui sixteen column grid">
                        <div class="ui row">
                          <div class="fourteen wide column">
                            <div class="ui very basic segment">
                              <h2 class="ui header">
                                {{ this.selectedPortfolio.portfolioName }}
                                <br />
                                <span class="ui sub header"
                                  >Portfolio Details
                                  <small
                                    v-if="selectedPortfolio.yearlyPerformances"
                                    >as at
                                    {{
                                      selectedPortfolio.yearlyPerformances[
                                        selectedPortfolio.yearlyPerformances
                                          .length - 1
                                      ].endDate
                                    }}</small
                                  ></span
                                >
                              </h2>
                            </div>
                          </div>
                        </div>
                        <div class="ui row">
                          <div class="three wide column">
                            <div class="ui vertical fluid tabular menu">
                              <a
                                :class="
                                  stats == 'positions' ? 'active item' : 'item'
                                "
                                @click.prevent="showStats('positions')"
                                >Positions</a
                              >
                              <a
                                :class="stats == 'aa' ? 'active item' : 'item'"
                                @click.prevent="showStats('aa')"
                                >Asset Allocation</a
                              >
                              <a
                                :class="
                                  stats == 'performance'
                                    ? 'active item'
                                    : 'item'
                                "
                                @click.prevent="showStats('performance')"
                                >Performance</a
                              >
                            </div>
                          </div>
                          <div class="thirteen wide column">
                            <div v-if="stats == 'aa'">
                              <ChartBarAaV2
                                v-if="
                                  currency == 'ZAR' &&
                                    contains(aaType, 'Simple')
                                "
                                :appearanceSettings="appearanceSettings"
                                :selectedPortfolio="selectedPortfolio"
                                :aaType="aaType"
                                :loading="loading"
                                :show="true"
                                v-show="true"
                              />
                              <ChartBarAaV2Extended
                                v-if="
                                  currency == 'ZAR' &&
                                    contains(aaType, 'Extended')
                                "
                                :appearanceSettings="appearanceSettings"
                                :aaType="aaType"
                                :loading="loading"
                                :selectedPortfolio="selectedPortfolio"
                                :show="true"
                                v-show="true"
                              />
                              <ChartBarAaV2Usd
                                v-if="currency == 'USD'"
                                :aaType="aaType"
                                :loading="loading"
                                :appearanceSettings="appearanceSettings"
                                :selectedPortfolio="selectedPortfolio"
                                :show="true"
                                v-show="true"
                              />
                            </div>
                            <div v-if="stats == 'positions'">
                              <Positions
                                :appearanceSettings="appearanceSettings"
                                :selectedPortfolio="selectedPortfolio"
                                :show="true"
                                v-show="true"
                              />
                            </div>
                            <div v-if="stats == 'performance'">
                              <PerformanceV2
                                v-if="currency == 'ZAR'"
                                :currency="currency"
                                :aaType="aaType"
                                :shortCurrency="shortCurrency"
                                :appearanceSettings="appearanceSettings"
                                :selectedPortfolio="selectedPortfolio"
                                :show="true"
                                v-show="true"
                              />
                              <PerformanceV2Usd
                                v-if="currency == 'USD'"
                                :currency="currency"
                                :aaType="aaType"
                                :customPortfolio="customPortfolio"
                                :shortCurrency="shortCurrency"
                                :appearanceSettings="appearanceSettings"
                                :selectedPortfolio="selectedPortfolio"
                                :show="true"
                                v-show="true"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="tabRight == 9">
                  <div class="ui segment" :id="colors[1].class">
                    <div class="ui row">
                      <div class="ui sixteen wide column">
                        <RiskProfiler
                          v-if="tabRight == 9"
                          :goalCreated="true"
                          :riskStep="riskStep"
                          :currency="currency"
                          :aaType="aaType"
                          v-on:goalRiskProfileChanged="
                            goalRiskProfileChanged($event)
                          "
                          v-on:changeRiskStep="changeRiskStep($event)"
                          v-on:changePrimaryStep="changePrimaryStep($event)"
                          :activePlan="projectionRequest"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as _ from "lodash";

//import { getPortfolios, AssetAllocation } from "@/utils/portfolios.js";
import {
  getCustomPortfolio,
  getPortfoliosGivenRisk,
  getGoalTypes,
  getCustomPortfolios,
  getIncomeCashFlowRequest,
  getContribution,
  getProjections,
  saveProjection,
  getSavedProjection,
  getClientV2,
  getAccountsV2,
  // getMdd,
  getPartnerSettings,
  getRiskNeed,
  getGoalRiskProfile,
  additionalGetIncomeCashFlowRequest,
  additionalGetContributionCashFlowRequest,
} from "@/gateway";

import {
  GetProjection,
  GoalInfo,
  GetIncomeCashFlowRequest,
  GetContributionCashFlowRequest,
} from "@/dtos";

import numeral from "numeral";

import RiskInputs from "@/components/RiskInputsV2.vue";
import AdvancedInputsV2 from "@/components/AdvancedInputsV2.vue";

import AppearanceInputsV2 from "@/components/AppearanceInputsV2.vue";
import Disclaimer from "@/components/DisclaimerV23.vue";
import InvestmentInputs from "@/components/InvestmentInputV2.vue";
import InvestmentLumpsumInputV21 from "@/components/InvestmentLumpsumInputV21.vue";
import InvestmentAdditionalInputV21 from "@/components/InvestmentAdditionalInputV21.vue";
import FeeInputs from "@/components/FeeInputs.vue";
import IncomeInput from "@/components/IncomeInputV2.vue";

import IncomeInputV21 from "@/components/IncomeAdditionalInputV21.vue";

import IncomeInputAdhocV21 from "@/components/IncomeInputAdhocV21.vue";
import GoalInput from "@/components/GoalInputV3.vue";

import ChartProjectedBalancesMedian from "@/components/ChartProjectedBalancesV2Median.vue";
import ChartProjectedBalancesDefault from "@/components/ChartProjectedBalancesV2.vue";

import ChartBarAaV2 from "@/components/ChartBarAaV2.vue";
import ChartBarAaV2Extended from "@/components/ChartBarAaV2Extended.vue";
import ChartBarAaV2Usd from "@/components/ChartBarAaV2Usd.vue";
import Positions from "@/components/PositionsV2.vue";

import PerformanceV2 from "@/components/PerformanceV2.vue";
import PerformanceV2Usd from "@/components/PerformanceV2Usd.vue";
import ChartProjectedIncomeDefault from "@/components/ChartProjectedIncomeV2.vue";
import ChartProjectedIncomeMedian from "@/components/ChartProjectedIncomeV3Median.vue";
import ChartTableProjectedIncomeMedian from "@/components/ChartTableProjectedIncomeV3Median.vue";
// risk profile

import RiskAbility from "@/components/NewGoalTypeRiskAbility.vue";
import RiskProfiler from "@/components/NewGoalTypeRiskProfiler.vue";
import RetirementAnnuityInputsV3 from "../components/v3/RetirementAnnuityInputsV3.vue";
import RetirementAnnuityOutputsV3 from "../components/v3/RetirementAnnuityOutputsV3.vue";

import LivingAnnuityInputsV3 from "../components/v3/LivingAnnuityInputsV3.vue";

export default {
  name: "home",
  components: {
    IncomeInput,
    IncomeInputV21,
    IncomeInputAdhocV21,
    GoalInput,
    Positions,
    ChartBarAaV2,
    ChartBarAaV2Extended,
    ChartBarAaV2Usd,
    ChartProjectedBalancesMedian,
    ChartProjectedBalancesDefault,
    ChartProjectedIncomeDefault,
    ChartProjectedIncomeMedian,

    ChartTableProjectedIncomeMedian,
    RiskInputs,
    AdvancedInputsV2,
    AppearanceInputsV2,
    InvestmentInputs,
    FeeInputs,
    PerformanceV2,
    PerformanceV2Usd,
    Disclaimer,
    RiskAbility,
    RiskProfiler,
    InvestmentAdditionalInputV21,
    InvestmentLumpsumInputV21,
    RetirementAnnuityInputsV3,
    RetirementAnnuityOutputsV3,
    LivingAnnuityInputsV3,
  },
  computed: {
    partnerCapitalMarketAssumptions() {
      if (this.projectionResponse.partnerCapitalMarketAssumptions)
        return this.projectionResponse.partnerCapitalMarketAssumptions;
      else return null;
    },
    shortCurrency() {
      if (this.currency == "ZAR") return "R";
      if (this.currency == "USD") return "$";

      return this.currency;
    },
    adhocInc() {
      if (this.additionalIncome.length > 0) return this.additionalIncome[0];
      else if (this.projectionRequest) {
        return this.projectionRequest.getIncomeCashFlowRequest.hasAdhocCashFlow;
      }
      return false;
    },
    adjustedAdditionalIncome() {
      let addIncomes = [];
      for (var i = 0; i < this.additionalIncome.length; i++) {
        var incm = _.clone(this.additionalIncome[i]);
        incm.keyIndex = i + 1;
        incm.incomeGrowth = incm.incomeGrowth / 100;
        addIncomes.push(incm);
      }
      return addIncomes;
    },
    adjustedContributions() {
      let addIncomes = [];
      for (var i = 0; i < this.additionalContributions.length; i++) {
        var incm = _.clone(this.additionalContributions[i]);
        incm.keyIndex = i + 1;
        incm.contributionGrowth = incm.contributionGrowth / 100;
        addIncomes.push(incm);
      }
      return addIncomes;
    },
    hasAdhocCashFlowComputed() {
      return this.adjustedAdditionalIncome[0].hasAdhocCashFlow;
    },
    goalPictureUrl() {
      if (this.goalTypes && this.projectionRequest) {
        for (var i = 0; i < this.goalTypes.length; i++) {
          var gt = this.goalTypes[i];
          if (gt.goalTypeEnum == this.projectionRequest.goalInfo.type) {
            return gt.goalTypePictureUrl;
          }
        }
      }
      return "";
    },
    partnerLogoUrl() {
      return this.$store.state.partnerLogoUrl;
    },

    partnerBackgroundUrl() {
      return this.$store.state.partnerBackgroundUrl;
    },
    selectedAccountProjections: function() {
      // if (this.selected.accountId == 0) {
      return this.projectionResponse.projections;
      /* } else {
        return _.filter(this.projectionResponse.accountProjections, {
          accountId: this.selected.accountId
        });
      }*/
    },
  },
  data() {
    return {
      currency: "ZAR",
      currentBalancesTab: "",
      currentIncomeTab: "",
      currentIncomeTableTab: "",
      loading: false,
      riskStep: "goalRiskProfile",
      updated: false,
      originalSavedRequest: null,
      goalTypes: null,
      colors: [
        {
          class: "bluebg",
          graph: {
            fontColor: "white",
            axisColor: "white",
            axisGridColor: "grey",
            graphColor: "black",
            averageLineColor: "black",
            bottomScenarioLineColor: "red",
          },
        },
        {
          class: "whitebg",
          graph: {
            fontColor: "grey",
            axisColor: "grey",
            axisGridColor: "white",
            graphColor: "green",
            averageLineColor: "black",
            bottomScenarioLineColor: "red",
          },
        },
      ],
      debug: false,
      showDisclaimer: false,
      highlightRangeDto: "Median",
      // mdd
      //mdd: [],

      // client name
      clientId: 0,
      clientGoalV2Id: 0,
      clientFirstName: "",
      clientLastName: "",
      email: "",

      // goal
      goalName: "#",
      goalDescription: "#",
      goalHasTarget: false,
      goalTarget: 10000,
      goalTargetAge: 75,
      goalType: "PostRetirement",
      wrapperType: "",
      //
      riskPortfolios: [],
      riskProfile: null,
      goalRiskProfile: null,
      riskTolerance: 5,
      riskCapacity: 5,
      selectedPortfolio: null,
      customPortfolio: null,

      // wrapper inputs:
      raInputsDto: {
        currentSalary: 0,
        retirementAge: 65,
        currentAge: 35,
        replacementRatio: 17.6,
        salaryGrowthRate: 6,
        contributionPercentage: 15,
        targetPercentage: 70,
        currentValueOfPensionFunds: 0,
        contributeAnnualBonus: true,
        annualBonusContributionPercentToRa: 0,
        annualBonusAsAPercentageOfSalary: 10,
        incomeNeeds: {
          target: 70,
          type: "TargetFinalYearSalary",
        },
      },
      laInputsDto: {
        incomeToLastUntilAge: 93,
        currentAge: 65,
        balance: 1000000,

        getIncomeCashFlowRequests: [
          {
            income: 40000,
            incomeGrowth: 5,
            incomeToLast: 93,
            startYear: 66,
          },
        ],

        enableGuardRails: false,
        guardRailsRule: {
          lowerPercentage: 4,
          upperPercentage: 10,
        },
        enableFreezeCashflow: true,

        enableCapitalPreservationRule: false,
        capitalPreservationRule: {
          spendingCut: 10,
          withdrawalRisesByMoreThan: 20,
          yearsToApply: 15,
        },
        enableProsperityRule: false,
        capitalProsperityRule: {
          spendingIncrease: 10,
          withdrawalRateFallsBy: 20,
          yearsToApply: 100,
        },
      },

      // inputs
      adjustForInflation: false,
      currentAge: 55,
      projectionRequest: null,
      tabLeft: 6,
      tabRight: 4,
      stats: "positions",
      selected: { accountId: 0 },
      accounts: [],
      portfolios: [],
      projectionResponse: [],
      statsResponse: [],

      // fees
      platformFee: 0,
      advisorFee: 0,
      otherCharges: 0,

      // investments
      getContributionCashFlowRequestR: null,
      getContributionCashFlowResponseR: null,
      applyContribution: false,
      contribution: 5000,
      contributionFrequency: 12,
      contributionGrowth: 6,
      contributionGrowthFrequency: 1,
      contributionToLast: 65,
      contributionStartYear: 55,

      // additional contributions
      additionalContributions: [
        {
          // key
          keyIndex: 1,

          // income
          contributionLabel: "Contribution",
          getContributionCashFlowRequestR: null,
          getContributionCashFlowResponseR: null,
          applyContribution: false,
          contribution: 5000,
          contributionFrequency: 12,
          contributionGrowth: 6,
          contributionGrowthFrequency: 1,
          contributionToLast: 65,
          contributionStartYear: 55,
        },
      ],

      // income

      getIncomeCashFlowRequestR: null,
      getIncomeCashFlowResponseR: null,

      // income
      incomeLabel: "Income",
      income: 10000,
      taxRate: 30,
      incomeGrowth: 6,
      incomeGrowthFrequency: 1,
      payoutFrequency: 12,
      incomeToLast: 93,
      startYear: 65,
      withdrawalStrategy: 0,

      //adhoc
      hasAdhocCashFlow: false,
      adhocCashFlowAge1: 0,
      adhocCashFlow1: 0,
      adhocCashFlowAge2: 0,
      adhocCashFlow2: 0,
      adhocCashFlowAge3: 0,
      adhocCashFlow3: 0,

      // additionalIncome
      additionalIncome: [
        {
          // key
          keyIndex: 1,

          getIncomeCashFlowRequestR: null,
          getIncomeCashFlowResponseR: null,

          // income
          incomeLabel: "Income",
          income: 0,
          taxRate: 30,
          incomeGrowth: 6,
          incomeGrowthFrequency: 1,
          payoutFrequency: 12,
          incomeToLast: 93,
          startYear: 65,
          withdrawalStrategy: 0,
          //
          hasAdhocCashFlow: false,
          adhocCashFlowAge1: 45,
          adhocCashFlow1: 0,
          adhocCashFlowAge2: 45,
          adhocCashFlow2: 0,
          adhocCashFlowAge3: 45,
          adhocCashFlow3: 0,
        },
      ],

      // adanved
      moreLikelyZScore: 0,
      lessLikelyZScore: 0,
      isFundAlphaEqualToFees: false,
      aaType: this.aaType,
      showLowestProjectedOutcome: true,
      appearanceSettings: { showMedianOutcome: false },
      showAdvisoryFees: false,
      showCashflowTable: false,
    };
  },
  watch: {
    async tabRight(newVal, oldVal) {
      if (newVal == 8) {
        // console.log(
        //    "bef this.selectedPortfolio.customPortfolioId",
        //    this.selectedPortfolio
        //  );
        const response = await getCustomPortfolio({
          currency: this.currency,
          id: this.selectedPortfolio.customPortfolioId,
          aaType: this.aaType,
        });

        if (response) {
          //console.log("response.portfolioview", response.portfolioView);

          this.selectedPortfolio = response.portfolioView;
          // console.log("tab changed and response received for cp", response);
          this.selectedPortfolio.customPortfolioId = response.result.id;
          this.customPortfolio = response.result;
          /*  this.selectedPortfolio.positions = response.portfolioView.positions;

          this.selectedPortfolio.yearlyPerformances =
            response.portfolioView.yearlyPerformances;
          this.selectedPortfolio.cumulativePerformances =
            response.portfolioView.cumulativePerformances;
          this.selectedPortfolio.currentAssetAllocation =
            response.portfolioView.currentAssetAllocation;*/

          // this.selectedPortfolio.aa = response.portfolioView.aa;
        }
      }
    },
  },

  methods: {
    contains(source, text) {
      if (source.includes(text)) return true;
      else return false;
    },
    helpfulIncomeLabel(incomeRequest) {
      var txt = "";
      if (incomeRequest.income >= 0 && incomeRequest.startYear) {
        txt =
          this.shortCurrency +
          " " +
          this.formatNr(incomeRequest.income, "0,0.0a");

        /*   { value: 12, text: "per month" },
        { value: 3, text: "per quarter" },
        { value: 1, text: "per annum" },
     */
        if (incomeRequest.payoutFrequency == 12) {
          txt += " pm";
        } else if (incomeRequest.payoutFrequency == 3) {
          txt += " pq";
        } else if (incomeRequest.payoutFrequency == 1) {
          txt += " pa";
        }
        //
        txt +=
          " from " +
          incomeRequest.startYear +
          " to " +
          incomeRequest.incomeToLast;
      }

      return txt;
    },
    helpfulContributionLabel(contrRequest) {
      var txt = "";
      if (
        contrRequest.contribution >= 0 &&
        contrRequest.contributionStartYear
      ) {
        txt =
          this.shortCurrency +
          " " +
          this.formatNr(contrRequest.contribution, "0,0.0a");

        /*   { value: 12, text: "per month" },
        { value: 3, text: "per quarter" },
        { value: 1, text: "per annum" },
     */
        if (contrRequest.contributionFrequency == 12) {
          txt += " pm";
        } else if (contrRequest.contributionFrequency == 3) {
          txt += " pq";
        } else if (contrRequest.contributionFrequency == 1) {
          txt += " pa";
        }
        //
        txt +=
          " from " +
          contrRequest.contributionStartYear +
          " to " +
          contrRequest.contributionToLast;
      }

      return txt;
    },
    showStats: function(val) {
      this.stats = val;
    },
    replace: function(original) {
      return original.replace(/\n/g, "<br />");
    },
    replaceLineBreaks: function(original) {
      return original.replace(/(?:\r\n|\r|\n)/g, "<br /><br />");
    },
    makeFriendlyJson: function(original) {
      return JSON.parse(original.stringify());
    },
    splitLineBreaks: function(original) {
      return original.split(/(?:\r\n|\r|\n)/g);
    },
    map: function(arr, obj) {
      return _.map(arr, _.partialRight(_.pick, obj));
    },
    flatten: function(arr) {
      return _.flattenDeep(arr);
    },
    filter: function(arr, filtr) {
      return _.filter(arr, filtr);
    },
    take: function(arr, size) {
      return _.take(arr, size);
    },
    formatNr(val, fmt) {
      if (fmt) return numeral(val).format(fmt);
      else return numeral(val).format("0,0.00a");
    },
    clickTab(t) {
      if (this.tab == t) this.tab = 0;
      else this.tab = t;
    },
    async addAdditionalRecurringIncome() {
      var lastKeyIndex = this.additionalIncome[this.additionalIncome.length - 1]
        .keyIndex;

      var keyIndex = lastKeyIndex + 1;
      var mockIncome = _.clone(this.additionalIncome[0]);
      mockIncome.income = 0;
      mockIncome.keyIndex = keyIndex;

      mockIncome.incomeLabel = "Income #" + keyIndex;
      mockIncome.adhocCashFlow1 = 0;
      mockIncome.adhocCashFlow2 = 0;
      mockIncome.adhocCashFlow3 = 0;
      this.additionalIncome.push(mockIncome);
    },
    async addAdditionalRecurringContribution() {
      var lastKeyIndex = this.additionalContributions[
        this.additionalContributions.length - 1
      ].keyIndex;

      var keyIndex = lastKeyIndex + 1;
      var mockIncome = _.clone(this.additionalContributions[0]);
      mockIncome.contribution = 0;
      mockIncome.keyIndex = keyIndex;

      mockIncome.contributionLabel = "Contribution #" + keyIndex;

      this.additionalContributions.push(mockIncome);
    },
    async cancelClick() {
      this.init();
      this.updated = false;
    },
    async goalRiskProfileChanged(event) {
      this.updated = true;
      this.projectionRequest.goalRiskProfile.getGoalRiskProfileResponse =
        event.getGoalRiskProfileResponse;

      this.goalRiskProfile.getGoalRiskProfileResponse =
        event.getGoalRiskProfileResponse;

      const response = await getPortfoliosGivenRisk({
        riskProfileId: this.goalRiskProfile.getGoalRiskProfileResponse
          .riskProfileId,
      });

      if (response) {
        this.riskPortfolios = response.result;
      }
    },
    changeRiskStep(event) {
      this.updated = true;
      this.riskStep = event.riskStep;
    },
    changePrimaryStep(event) {
      this.updated = true;
      this.step = event.step;
    },
    async saveClick() {
      this.loading = true;
      // get underlying cusotm portfolio positnos and performances and save to projectionrequest
      const cp = await getCustomPortfolio({
        currency: this.currency,
        id: this.selectedPortfolio.customPortfolioId,
        loadUnderlyingData: true,
        aaType: this.aaType,
      });

      if (cp) {
        this.projectionRequest.accounts[0].portfolios[0].portfolio =
          cp.portfolioView;
        this.projectionRequest.accounts[0].portfolios[0].portfolio.customPortfolioId =
          cp.result.id;

        // add aa
        this.projectionRequest.accounts[0].portfolios[0].portfolio.portfolioName = this.selectedPortfolio.portfolioName;
        this.projectionRequest.accounts[0].portfolios[0].portfolio.assetAllocation.localCash = this.selectedPortfolio.localCash;
        this.projectionRequest.accounts[0].portfolios[0].portfolio.assetAllocation.localBonds = this.selectedPortfolio.localBonds;
        this.projectionRequest.accounts[0].portfolios[0].portfolio.assetAllocation.localEquity = this.selectedPortfolio.localEquity;
        this.projectionRequest.accounts[0].portfolios[0].portfolio.assetAllocation.localProperty = this.selectedPortfolio.localProperty;
        this.projectionRequest.accounts[0].portfolios[0].portfolio.assetAllocation.foreignCash = this.selectedPortfolio.foreignCash;
        this.projectionRequest.accounts[0].portfolios[0].portfolio.assetAllocation.foreignBonds = this.selectedPortfolio.foreignBonds;
        this.projectionRequest.accounts[0].portfolios[0].portfolio.assetAllocation.foreignEquity = this.selectedPortfolio.foreignEquity;
        this.projectionRequest.accounts[0].portfolios[0].portfolio.assetAllocation.foreignProperty = this.selectedPortfolio.foreignProperty;

        // offshore
        this.projectionRequest.accounts[0].portfolios[0].portfolio.assetAllocation.globalCash = this.selectedPortfolio.globalCash;
        this.projectionRequest.accounts[0].portfolios[0].portfolio.assetAllocation.globalBonds = this.selectedPortfolio.globalBonds;
        this.projectionRequest.accounts[0].portfolios[0].portfolio.assetAllocation.globalInvestmentGrade = this.selectedPortfolio.globalInvestmentGrade;
        this.projectionRequest.accounts[0].portfolios[0].portfolio.assetAllocation.globalHighYield = this.selectedPortfolio.globalHighYield;
        this.projectionRequest.accounts[0].portfolios[0].portfolio.assetAllocation.globalEmergingMarketBonds = this.selectedPortfolio.globalEmergingMarketBonds;
        this.projectionRequest.accounts[0].portfolios[0].portfolio.assetAllocation.africaEuroBondsExSouthAfrica = this.selectedPortfolio.africaEuroBondsExSouthAfrica;
        this.projectionRequest.accounts[0].portfolios[0].portfolio.assetAllocation.globalProperty = this.selectedPortfolio.globalProperty;
        this.projectionRequest.accounts[0].portfolios[0].portfolio.assetAllocation.globalEquity = this.selectedPortfolio.globalEquity;
        this.projectionRequest.accounts[0].portfolios[0].portfolio.assetAllocation.globalEquitySmallCapStocks = this.selectedPortfolio.globalEquitySmallCapStocks;
        this.projectionRequest.accounts[0].portfolios[0].portfolio.assetAllocation.globalEmergingMarketEquity = this.selectedPortfolio.globalEmergingMarketEquity;
        this.projectionRequest.accounts[0].portfolios[0].portfolio.assetAllocation.globalHedgeFunds = this.selectedPortfolio.globalHedgeFunds;
        this.projectionRequest.accounts[0].portfolios[0].portfolio.assetAllocation.listedPrivateEquity = this.selectedPortfolio.listedPrivateEquity;
        this.projectionRequest.accounts[0].portfolios[0].portfolio.assetAllocation.listedInfrastructure = this.selectedPortfolio.listedInfrastructure;
        this.projectionRequest.accounts[0].portfolios[0].portfolio.assetAllocation.localCredit = this.selectedPortfolio.localCredit;
        this.projectionRequest.accounts[0].portfolios[0].portfolio.assetAllocation.localInfrastructure = this.selectedPortfolio.localInfrastructure;

        this.projectionRequest.accounts[0].portfolios[0].portfolio.assetAllocation.globalIncomeOpportunities = this.selectedPortfolio.globalIncomeOpportunities;

        // change
        // let pr = this.projectionRequest;

        // console.log("saving click");
        var saveClientGoal = {
          clientId: this.$route.params.clientid,
          clientGoalV2Id: this.$route.params.id,
          requestObject: this.projectionRequest,
          responseObject: this.projectionResponse,
        };
        saveClientGoal.requestObject.additionalGetIncomeCashFlowRequests = this.additionalIncome;
        saveClientGoal.requestObject.additionalGetContributionCashFlowRequests = this.additionalContributions;

        // console.log("saveClientGoal", saveClientGoal);
        const response = await saveProjection(saveClientGoal);
        if (response && this.$route.params.id == 0) {
          this.loading = false;
          this.$router.push(
            "/v3/client/" +
              this.$route.params.clientid +
              "/goals/" +
              response.result
          );
        } else {
          this.loading = false;
        }
        this.updated = false;
      }
    },
    async init() {
      console.log("init 1");
      const aresponse = await getAccountsV2();
      console.log("init 1a");
      if (aresponse) {
        this.accounts = aresponse.result;
        var id = this.$route.params.id;
        var clientId = this.$route.params.clientid;
        this.clientId = clientId;

        // get goal types
        const goalTypesresponse = await getGoalTypes({
          clientId: this.clientId,
        });
        if (goalTypesresponse) {
          this.goalTypes = goalTypesresponse.result;
        }

        console.log("init 2");
        this.id = id;
        //  this.portfolios = getPortfolios();
        if (id != 0) {
          const oresponse = await getSavedProjection({
            id: id,
            clientId: clientId,
          });
          console.log("init 3");
          if (oresponse) {
            console.log("oresponse", oresponse.result);
            this.originalSavedRequest = oresponse.result;
            // add all the inputs
            // goal
            this.goalName = this.originalSavedRequest.requestObject.goalInfo.goalName;
            this.goalDescription = this.originalSavedRequest.requestObject.goalInfo.goalDescription;
            this.goalHasTarget = this.originalSavedRequest.requestObject.goalInfo.goalHasTarget;
            this.goalTarget = this.originalSavedRequest.requestObject.goalInfo.goalTarget;
            this.goalTargetAge = this.originalSavedRequest.requestObject.goalInfo.goalTargetAge;
            this.wrapperType = this.originalSavedRequest.requestObject.goalInfo.wrapperType;

            if (this.originalSavedRequest.requestObject.goalInfo.type)
              this.goalType = this.originalSavedRequest.requestObject.goalInfo.type;
            else this.goalType = "Emergency";

            // currency
            if (this.originalSavedRequest.requestObject.goalInfo.currency)
              this.currency = this.originalSavedRequest.requestObject.goalInfo.currency;
            else this.currency = "ZAR";

            // client name and details
            this.currentAge = this.originalSavedRequest.requestObject.currentAge;

            //
            this.adjustForInflation = this.originalSavedRequest.requestObject.adjustForInflation;

            // contribution
            this.applyContribution = this.originalSavedRequest.requestObject.getContributionCashFlowRequest.applyContribution;

            this.contribution = this.originalSavedRequest.requestObject.getContributionCashFlowRequest.contribution;
            this.contributionFrequency = this.originalSavedRequest.requestObject.getContributionCashFlowRequest.contributionFrequency;
            this.contributionGrowth =
              this.originalSavedRequest.requestObject
                .getContributionCashFlowRequest.contributionGrowth * 100;
            this.contributionGrowthFrequency = this.originalSavedRequest.requestObject.getContributionCashFlowRequest.contributionGrowthFrequency;
            this.contributionStartYear = this.originalSavedRequest.requestObject.getContributionCashFlowRequest.contributionStartYear;
            this.contributionToLast = this.originalSavedRequest.requestObject.getContributionCashFlowRequest.contributionToLast;

            if (
              this.originalSavedRequest.requestObject
                .additionalGetContributionCashFlowRequests.length == 0
            ) {
              this.additionalContributions[0].keyIndex = 1;
              this.additionalContributions[0].contributionLabel =
                "Contributions";

              this.additionalContributions[0].contribution = this.originalSavedRequest.requestObject.getContributionCashFlowRequest.contribution;
              this.additionalContributions[0].contributionFrequency = this.originalSavedRequest.requestObject.getContributionCashFlowRequest.contributionFrequency;
              this.additionalContributions[0].contributionGrowth =
                this.originalSavedRequest.requestObject
                  .getContributionCashFlowRequest.contributionGrowth * 100;

              this.additionalContributions[0].contributionGrowthFrequency = this.originalSavedRequest.requestObject.getContributionCashFlowRequest.contributionGrowthFrequency;
              this.additionalContributions[0].contributionStartYear = this.originalSavedRequest.requestObject.getContributionCashFlowRequest.contributionStartYear;
              this.additionalContributions[0].contributionToLast = this.originalSavedRequest.requestObject.getContributionCashFlowRequest.contributionToLast;
            } else {
              console.log("init 3a else - ");

              this.additionalContributions = this.originalSavedRequest.requestObject.additionalGetContributionCashFlowRequests;
            }
            console.log("init 3a => ", this.additionalContributions);
            console.log("init 4");
            // income
            if (
              this.originalSavedRequest.requestObject.getIncomeCashFlowRequest
            ) {
              this.income = this.originalSavedRequest.requestObject.getIncomeCashFlowRequest.income;
              this.taxRate = this.originalSavedRequest.requestObject.getIncomeCashFlowRequest.taxRate;
              this.incomeToLast = this.originalSavedRequest.requestObject.getIncomeCashFlowRequest.incomeToLast;
              this.currentAge = this.originalSavedRequest.requestObject.getIncomeCashFlowRequest.currentAge;
              this.incomeGrowth =
                this.originalSavedRequest.requestObject.getIncomeCashFlowRequest
                  .incomeGrowth * 100;

              console.log("init 5a");
              this.incomeGrowthFrequency = this.originalSavedRequest.requestObject.getIncomeCashFlowRequest.incomeGrowthFrequency;
              this.payoutFrequency = this.originalSavedRequest.requestObject.getIncomeCashFlowRequest.payoutFrequency;
              this.startYear = this.originalSavedRequest.requestObject.getIncomeCashFlowRequest.startYear;
              this.hasAdhocCashFlow = this.originalSavedRequest.requestObject.getIncomeCashFlowRequest.hasAdhocCashFlow;
              this.adhocCashFlowAge1 = this.originalSavedRequest.requestObject.getIncomeCashFlowRequest.adhocCashFlowAge1;
              this.adhocCashFlow1 = this.originalSavedRequest.requestObject.getIncomeCashFlowRequest.adhocCashFlow1;
              this.adhocCashFlowAge2 = this.originalSavedRequest.requestObject.getIncomeCashFlowRequest.adhocCashFlowAge2;
              this.adhocCashFlow2 = this.originalSavedRequest.requestObject.getIncomeCashFlowRequest.adhocCashFlow2;
              this.adhocCashFlowAge3 = this.originalSavedRequest.requestObject.getIncomeCashFlowRequest.adhocCashFlowAge3;
              this.adhocCashFlow3 = this.originalSavedRequest.requestObject.getIncomeCashFlowRequest.adhocCashFlow3;

              console.log("init 5b");
            }

            // load it to additionalIncomeRequest v2.1 needs to be backwards compatible.
            //
            if (
              !this.originalSavedRequest.requestObject
                .additionalGetIncomeCashFlowRequests ||
              this.originalSavedRequest.requestObject
                .additionalGetIncomeCashFlowRequests.length == 0
            ) {
              this.additionalIncome[0].keyIndex = 1;
              this.additionalIncome[0].income = this.originalSavedRequest.requestObject.getIncomeCashFlowRequest.income;
              this.additionalIncome[0].taxRate = this.originalSavedRequest.requestObject.getIncomeCashFlowRequest.taxRate;
              this.additionalIncome[0].incomeToLast = this.originalSavedRequest.requestObject.getIncomeCashFlowRequest.incomeToLast;
              this.additionalIncome[0].currentAge = this.originalSavedRequest.requestObject.getIncomeCashFlowRequest.currentAge;
              this.additionalIncome[0].incomeGrowth =
                this.originalSavedRequest.requestObject.getIncomeCashFlowRequest
                  .incomeGrowth * 100;

              this.additionalIncome[0].incomeGrowthFrequency = this.originalSavedRequest.requestObject.getIncomeCashFlowRequest.incomeGrowthFrequency;
              this.additionalIncome[0].payoutFrequency = this.originalSavedRequest.requestObject.getIncomeCashFlowRequest.payoutFrequency;
              this.additionalIncome[0].startYear = this.originalSavedRequest.requestObject.getIncomeCashFlowRequest.startYear;
              // this.additionalIncome[0].hasAdhocCashFlow = this.originalSavedRequest.requestObject.getIncomeCashFlowRequest.hasAdhocCashFlow;
              this.additionalIncome[0].hasAdhocCashFlow = this.originalSavedRequest.requestObject.getIncomeCashFlowRequest.hasAdhocCashFlow;
              this.additionalIncome[0].adhocCashFlowAge1 = this.originalSavedRequest.requestObject.getIncomeCashFlowRequest.adhocCashFlowAge1;
              this.additionalIncome[0].adhocCashFlow1 = this.originalSavedRequest.requestObject.getIncomeCashFlowRequest.adhocCashFlow1;
              this.additionalIncome[0].adhocCashFlowAge2 = this.originalSavedRequest.requestObject.getIncomeCashFlowRequest.adhocCashFlowAge2;
              this.additionalIncome[0].adhocCashFlow2 = this.originalSavedRequest.requestObject.getIncomeCashFlowRequest.adhocCashFlow2;
              //  this.additionalIncome[0].adhocCashFlowAge3 = this.originalSavedRequest.requestObject.getIncomeCashFlowRequest.adhocCashFlowAge3;
              //    this.additionalIncome[0].adhocCashFlow3 = this.originalSavedRequest.requestObject.getIncomeCashFlowRequest.adhocCashFlow3;
            } else {
              this.additionalIncome = this.originalSavedRequest.requestObject.additionalGetIncomeCashFlowRequests;
            }
            console.log("init 6");
            // fees
            this.platformFee = this.originalSavedRequest.requestObject.platformFee;
            this.advisorFee = this.originalSavedRequest.requestObject.advisorFee;
            this.otherCharges = this.originalSavedRequest.requestObject.otherCharges;

            // risk  & portfolio
            var response1 = await getCustomPortfolios({
              currency: this.currency,
              loadUnderlyingData: false,
              aaType: this.aaType,
            });
            if (response1) {
              var response = await getPortfoliosGivenRisk({
                riskProfileId: this.originalSavedRequest.requestObject
                  .riskProfile.id,
              });

              if (response) {
                console.log("init 7");
                this.riskPortfolios = response.result;

                this.riskProfile = this.originalSavedRequest.requestObject.riskProfile;
                if (!this.selectedPortfolio) {
                  this.selectedPortfolio = _.filter(this.riskPortfolios, {
                    customPortfolioId: this.originalSavedRequest.requestObject
                      .accounts[0].portfolios[0].portfolio.customPortfolioId,
                  })[0]; //this.originalSavedRequest.requestObject.accounts[0].portfolios[0].portfolio;
                }

                // this.accounts[0].portfolios[0].positions = this.selectedPortfolio.positions;
                //  this.accounts[0].portfolios[0].portfolio.accountMarketValue = this.originalSavedRequest.requestObject.accounts[0].accountMarketValue;
                this.accounts[0].accountMarketValue = this.originalSavedRequest.requestObject.accounts[0].accountMarketValue;
                this.accounts[0].portfolios[0].portfolio.customPortfolioId = this.originalSavedRequest.requestObject.accounts[0].portfolios[0].portfolio.customPortfolioId;
                this.accounts[0].portfolios[0].portfolio.portfolioName = this.selectedPortfolio.portfolioName;

                this.accounts[0].portfolios[0].portfolio.assetAllocation.localCash = this.selectedPortfolio.localCash;
                this.accounts[0].portfolios[0].portfolio.assetAllocation.localBonds = this.selectedPortfolio.localBonds;
                this.accounts[0].portfolios[0].portfolio.assetAllocation.localEquity = this.selectedPortfolio.localEquity;
                this.accounts[0].portfolios[0].portfolio.assetAllocation.localProperty = this.selectedPortfolio.localProperty;
                this.accounts[0].portfolios[0].portfolio.assetAllocation.foreignCash = this.selectedPortfolio.foreignCash;
                this.accounts[0].portfolios[0].portfolio.assetAllocation.foreignBonds = this.selectedPortfolio.foreignBonds;
                this.accounts[0].portfolios[0].portfolio.assetAllocation.foreignEquity = this.selectedPortfolio.foreignEquity;
                this.accounts[0].portfolios[0].portfolio.assetAllocation.foreignProperty = this.selectedPortfolio.foreignProperty;

                // offshore
                this.accounts[0].portfolios[0].portfolio.assetAllocation.globalCash = this.selectedPortfolio.globalCash;
                this.accounts[0].portfolios[0].portfolio.assetAllocation.globalBonds = this.selectedPortfolio.globalBonds;
                this.accounts[0].portfolios[0].portfolio.assetAllocation.globalInvestmentGrade = this.selectedPortfolio.globalInvestmentGrade;
                this.accounts[0].portfolios[0].portfolio.assetAllocation.globalHighYield = this.selectedPortfolio.globalHighYield;
                this.accounts[0].portfolios[0].portfolio.assetAllocation.globalEmergingMarketBonds = this.selectedPortfolio.globalEmergingMarketBonds;
                this.accounts[0].portfolios[0].portfolio.assetAllocation.africaEuroBondsExSouthAfrica = this.selectedPortfolio.africaEuroBondsExSouthAfrica;
                this.accounts[0].portfolios[0].portfolio.assetAllocation.globalProperty = this.selectedPortfolio.globalProperty;
                this.accounts[0].portfolios[0].portfolio.assetAllocation.globalEquity = this.selectedPortfolio.globalEquity;
                this.accounts[0].portfolios[0].portfolio.assetAllocation.globalEquitySmallCapStocks = this.selectedPortfolio.globalEquitySmallCapStocks;
                this.accounts[0].portfolios[0].portfolio.assetAllocation.globalEmergingMarketEquity = this.selectedPortfolio.globalEmergingMarketEquity;
                this.accounts[0].portfolios[0].portfolio.assetAllocation.globalHedgeFunds = this.selectedPortfolio.globalHedgeFunds;
                this.accounts[0].portfolios[0].portfolio.assetAllocation.listedPrivateEquity = this.selectedPortfolio.listedPrivateEquity;
                this.accounts[0].portfolios[0].portfolio.assetAllocation.listedInfrastructure = this.selectedPortfolio.listedInfrastructure;
                this.accounts[0].portfolios[0].portfolio.assetAllocation.localInfrastructure = this.selectedPortfolio.localInfrastructure;
                this.accounts[0].portfolios[0].portfolio.assetAllocation.localCredit = this.selectedPortfolio.localCredit;
                this.accounts[0].portfolios[0].portfolio.assetAllocation.globalIncomeOpportunities = this.selectedPortfolio.globalIncomeOpportunities;

                this.accounts[0].portfolios[0].portfolio.targetTic = this.selectedPortfolio.targetTic;
                //  advanced
                //  if (this.originalSavedRequest.requestObject.appearanceSettings)
                //   this.appearanceSettings = this.originalSavedRequest.requestObject.appearanceSettings;

                this.moreLikelyZScore =
                  this.originalSavedRequest.requestObject.moreLikelyZScore ||
                  0.8416;
                this.lessLikelyZScore =
                  this.originalSavedRequest.requestObject.lessLikelyZScore ||
                  1.6449;
                this.showLowestProjectedOutcome =
                  this.originalSavedRequest.requestObject
                    .showLowestProjectedOutcome || true;

                if (this.originalSavedRequest.requestObject.goalRiskProfile)
                  this.goalRiskProfile = this.originalSavedRequest.requestObject.goalRiskProfile;

                this.isFundAlphaEqualToFees =
                  this.originalSavedRequest.requestObject
                    .isFundAlphaEqualToFees || false;
                this.aaType =
                  this.originalSavedRequest.requestObject.aaType || "Simple";
                if (this.originalSavedRequest.requestObject.raInputsDto)
                  this.raInputsDto = this.originalSavedRequest.requestObject.raInputsDto;
                const partnerSettingsResponse = await getPartnerSettings();
                if (partnerSettingsResponse) {
                  this.showAdvisoryFees =
                    partnerSettingsResponse.partnerDefaultSettings
                      .showAdvisoryFees || false;
                  this.showCashflowTable =
                    partnerSettingsResponse.partnerDefaultSettings
                      .showCashflowTable || false;
                  //if (!this.appearanceSettings)
                  this.appearanceSettings =
                    partnerSettingsResponse.partnerDefaultSettings.appearanceSettings;

                  // component name for projected balances

                  this.currentBalancesTab =
                    "ChartProjectedBalances" +
                    partnerSettingsResponse.partnerDefaultSettings
                      .appearanceSettings.projectedComponentName;
                  this.currentIncomeTab =
                    "ChartProjectedIncome" +
                    partnerSettingsResponse.partnerDefaultSettings
                      .appearanceSettings.projectedComponentName;

                  this.currentIncomeTableTab =
                    "ChartTableProjectedIncomeMedian";
                }
                console.log("init 9 ---> update Projection");
                console.log(
                  "init 10 ---> additoinalIncome",
                  this.additionalIncome
                );
                console.log(
                  "init 10a ---> additadhocIncoinalIncome",
                  this.adhocInc
                );
                this.updateProjection();
              }
            }

            // advanced
            //   this.appearanceSettings = this.originalSavedRequest.requestObject.appearanceSettings;
            this.moreLikelyZScore =
              this.originalSavedRequest.requestObject.moreLikelyZScore ||
              0.8416;
            this.lessLikelyZScore =
              this.originalSavedRequest.requestObject.lessLikelyZScore ||
              1.6449;
            this.showLowestProjectedOutcome =
              this.originalSavedRequest.requestObject
                .showLowestProjectedOutcome || true;

            this.isFundAlphaEqualToFees =
              this.originalSavedRequest.requestObject.isFundAlphaEqualToFees ||
              false;
            this.aaType =
              this.originalSavedRequest.requestObject.aaType || "Simple";
            if (this.originalSavedRequest.requestObject.raInputsDto)
              this.raInputsDto = this.originalSavedRequest.requestObject.raInputsDto;
            if (this.originalSavedRequest.requestObject.raInputsDto)
              this.laInputsDto = this.originalSavedRequest.requestObject.laInputsDto;
          }
        } else {
          var response11 = await getCustomPortfolios({
            currency: this.currency,
            loadUnderlyingData: false,
            aaType: this.aaType,
          });
          if (response11) {
            var response12 = await getPortfoliosGivenRisk({
              riskProfileId: response11.result[0].riskProfile.id,
            });

            // console.log("response risk portfolios", response12.result);

            this.riskPortfolios = response12.result;
            this.riskProfile = response12.result[0].riskProfile;

            if (!this.selectedPortfolio) {
              if (
                _.filter(this.riskPortfolios, {
                  isWithinRiskNumber: true,
                }).length == 0
              ) {
                this.selectedPortfolio = this.riskPortfolios[0];
              } else {
                this.selectedPortfolio = _.filter(this.riskPortfolios, {
                  isWithinRiskNumber: true,
                })[0];
              }
            } else {
              this.selectedPortfolio = _.filter(this.riskPortfolios, {
                id: this.selectedPortfolio.id,
              })[0];
            }

            //    console.log("this.selectedPortfolio", this.selectedPortfolio);
            // this.accounts[0].portfolios[0].positions = this.selectedPortfolio.positions;
            this.accounts[0].portfolios[0].portfolio.portfolioName = this.selectedPortfolio.portfolioName;
            this.accounts[0].portfolios[0].portfolio.assetAllocation.localCash = this.selectedPortfolio.localCash;
            this.accounts[0].portfolios[0].portfolio.assetAllocation.localBonds = this.selectedPortfolio.localBonds;
            this.accounts[0].portfolios[0].portfolio.assetAllocation.localEquity = this.selectedPortfolio.localEquity;
            this.accounts[0].portfolios[0].portfolio.assetAllocation.localProperty = this.selectedPortfolio.localProperty;
            this.accounts[0].portfolios[0].portfolio.assetAllocation.foreignCash = this.selectedPortfolio.foreignCash;
            this.accounts[0].portfolios[0].portfolio.assetAllocation.foreignBonds = this.selectedPortfolio.foreignBonds;
            this.accounts[0].portfolios[0].portfolio.assetAllocation.foreignEquity = this.selectedPortfolio.foreignEquity;
            this.accounts[0].portfolios[0].portfolio.assetAllocation.foreignProperty = this.selectedPortfolio.foreignProperty;

            //offshore
            this.accounts[0].portfolios[0].portfolio.assetAllocation.globalCash = this.selectedPortfolio.globalCash;
            this.accounts[0].portfolios[0].portfolio.assetAllocation.globalBonds = this.selectedPortfolio.globalBonds;
            this.accounts[0].portfolios[0].portfolio.assetAllocation.globalInvestmentGrade = this.selectedPortfolio.globalInvestmentGrade;
            this.accounts[0].portfolios[0].portfolio.assetAllocation.globalHighYield = this.selectedPortfolio.globalHighYield;
            this.accounts[0].portfolios[0].portfolio.assetAllocation.globalEmergingMarketBonds = this.selectedPortfolio.globalEmergingMarketBonds;
            this.accounts[0].portfolios[0].portfolio.assetAllocation.africaEuroBondsExSouthAfrica = this.selectedPortfolio.africaEuroBondsExSouthAfrica;
            this.accounts[0].portfolios[0].portfolio.assetAllocation.globalProperty = this.selectedPortfolio.globalProperty;
            this.accounts[0].portfolios[0].portfolio.assetAllocation.globalEquity = this.selectedPortfolio.globalEquity;
            this.accounts[0].portfolios[0].portfolio.assetAllocation.globalEquitySmallCapStocks = this.selectedPortfolio.globalEquitySmallCapStocks;
            this.accounts[0].portfolios[0].portfolio.assetAllocation.globalEmergingMarketEquity = this.selectedPortfolio.globalEmergingMarketEquity;
            this.accounts[0].portfolios[0].portfolio.assetAllocation.globalHedgeFunds = this.selectedPortfolio.globalHedgeFunds;
            this.accounts[0].portfolios[0].portfolio.assetAllocation.listedPrivateEquity = this.selectedPortfolio.listedPrivateEquity;
            this.accounts[0].portfolios[0].portfolio.assetAllocation.listedInfrastructure = this.selectedPortfolio.listedInfrastructure;
            this.accounts[0].portfolios[0].portfolio.assetAllocation.localCredit = this.selectedPortfolio.localCredit;
            this.accounts[0].portfolios[0].portfolio.assetAllocation.localInfrastructure = this.selectedPortfolio.localInfrastructure;
            this.accounts[0].portfolios[0].portfolio.assetAllocation.globalIncomeOpportunities = this.selectedPortfolio.globalIncomeOpportunities;

            if (response12.result[0].goalRiskProfile)
              this.goalRiskProfile = response12.result[0].goalRiskProfile;

            // advanced
            const partnerSettingsResponse = await getPartnerSettings();
            if (partnerSettingsResponse) {
              this.moreLikelyZScore =
                partnerSettingsResponse.partnerDefaultSettings
                  .moreLikelyZScore || 0.8416;
              this.lessLikelyZScore =
                partnerSettingsResponse.partnerDefaultSettings
                  .lessLikelyZScore || 1.6449;
              this.showLowestProjectedOutcome =
                partnerSettingsResponse.partnerDefaultSettings
                  .showLowestProjectedOutcome || true;
              this.showAdvisoryFees =
                partnerSettingsResponse.partnerDefaultSettings
                  .showAdvisoryFees || false;

              this.appearanceSettings =
                partnerSettingsResponse.partnerDefaultSettings.appearanceSettings;

              this.isFundAlphaEqualToFees =
                partnerSettingsResponse.partnerDefaultSettings
                  .isFundAlphaEqualToFees || false;
              this.aaType =
                partnerSettingsResponse.partnerDefaultSettings.aaType ||
                "Simple";
              this.showCashflowTable =
                partnerSettingsResponse.partnerDefaultSettings
                  .showCashflowTable || false;
              this.updateProjection();
            }
          }
        }
      }
    },
    async handleDisclaimerChanged(event) {
      this.showDisclaimer = event.showDisclaimer;
    },
    async handleInflationChanged(event) {
      this.updated = true;
      this.adjustForInflation = event.adjustForInflation;
      this.updateProjection();
    },
    async handleHighlightRangeDtoChanged(event) {
      this.updated = true;
      this.highlightRangeDto = event.highlightRangeDto;
      // this.updateProjection();
    },
    async handleIncomeChanged(indx, event) {
      this.updated = true;
      var keyIndex = indx;

      for (var i = 0; i < this.additionalIncome.length; i++) {
        var applicabaleIncome = this.additionalIncome[i];

        if (applicabaleIncome.keyIndex == keyIndex) {
          this.additionalIncome[i].incomeLabel = event.incomeLabel; //event.incomeLabel;
          this.additionalIncome[i].income = event.income;
          this.additionalIncome[i].taxRate = event.taxRate;
          this.additionalIncome[i].incomeGrowth = event.incomeGrowth;
          this.additionalIncome[i].incomeGrowthFrequency =
            event.incomeGrowthFrequency;
          this.additionalIncome[i].payoutFrequency = event.payoutFrequency;
          this.additionalIncome[i].incomeToLast = event.incomeToLast;
          this.additionalIncome[i].startYear = event.startYear;
          this.additionalIncome[i].withdrawalStrategy =
            event.withdrawalStrategy;

          this.updateProjection();
        }
      }
      //    console.log("handleIncomeChanged", event);
    },
    async handleAdhocIncomeChanged(event) {
      this.updated = true;

      this.additionalIncome[0].hasAdhocCashFlow = event.hasAdhocCashFlow; //event.incomeLabel;
      this.additionalIncome[0].adhocCashFlowAge1 = event.adhocCashFlowAge1;
      this.additionalIncome[0].adhocCashFlowAge2 = event.adhocCashFlowAge2;
      //  this.additionalIncome[0].adhocCashFlowAge3 = event.adhocCashFlowAge4;
      this.additionalIncome[0].adhocCashFlow1 = event.adhocCashFlow1;
      this.additionalIncome[0].adhocCashFlow2 = event.adhocCashFlow2;
      // this.additionalIncome[0].adhocCashFlow3 = event.adhocCashFlow3;
      this.updateProjection();
    },
    async handleIncomeLabelChanged(indx, event) {
      this.updated = true;
      var keyIndex = indx;
      for (var i = 0; i < this.additionalIncome.length; i++) {
        var applicabaleIncome = this.additionalIncome[i];

        if (applicabaleIncome.keyIndex == keyIndex) {
          this.additionalIncome[i].incomeLabel = event.incomeLabel; //event.incomeLabel;
        }
      }
      //    console.log("handleIncomeChanged", event);
    },
    async removeAdditionalIncome(event) {
      this.updated = true;
      var keyIndex = event.keyIndex;

      let addIncome = [];
      for (var i = 0; i < this.additionalIncome.length; i++) {
        var applicabaleIncome = _.clone(this.additionalIncome[i]);
        if (applicabaleIncome.keyIndex != keyIndex) {
          addIncome.push(applicabaleIncome);
        }
      }
      this.additionalIncome = addIncome;
      this.updateProjection();
    },
    async handleContributionLabelChanged(indx, event) {
      this.updated = true;
      var keyIndex = indx;
      for (var i = 0; i < this.additionalContributions.length; i++) {
        var additionalContribution = this.additionalContributions[i];

        if (additionalContribution.keyIndex == keyIndex) {
          this.additionalContributions[i].contributionLabel =
            event.contributionLabel; //event.incomeLabel;
        }
      }
      //    console.log("handleIncomeChanged", event);
    },
    async removeAdditionalContribution(event) {
      this.updated = true;
      var keyIndex = event.keyIndex;

      let addContr = [];
      for (var i = 0; i < this.additionalContributions.length; i++) {
        var applicabaleContr = _.clone(this.additionalContributions[i]);
        if (applicabaleContr.keyIndex != keyIndex) {
          addContr.push(applicabaleContr);
        }
      }
      this.additionalContributions = addContr;
      this.updateProjection();
    },
    async handleInvestmentChanged(indx, event) {
      // console.log(event);
      this.updated = true;

      for (var i = 0; i < this.additionalContributions.length; i++) {
        var additionalContribution = this.additionalContributions[i];

        if (additionalContribution.keyIndex == indx) {
          this.additionalContributions[i].contribution = event.contribution;
          this.additionalContributions[i].contributionFrequency =
            event.contributionFrequency;
          this.additionalContributions[i].contributionGrowth =
            event.contributionGrowth;
          this.additionalContributions[i].contributionGrowthFrequency =
            event.contributionGrowthFrequency;
          this.additionalContributions[i].contributionToLast =
            event.contributionToLast;
          this.additionalContributions[i].contributionStartYear =
            event.contributionStartYear;
          this.additionalContributions[i].withdrawalStrategy =
            event.withdrawalStrategy;
        }
      }
      this.updateProjection();
    },
    async handleWrapperInputsChanged(event) {
      console.log("v3 goal projection", event);
      //  this.raInputsDto = event;
      this.updateProjection();
    },
    async updateProjection() {
      this.loading = true;
      console.log("update proj 1");
      this.getIncomeCashFlowRequestR = new GetIncomeCashFlowRequest({
        income: this.income,
        incomeGrowth: this.incomeGrowth / 100,
        incomeGrowthFrequency: this.incomeGrowthFrequency,
        payoutFrequency: this.payoutFrequency,
        incomeToLast: this.incomeToLast,
        startYear: this.startYear,
        currentAge: this.currentAge,
        //withdrawalStrategy: this.withdrawalStrategy,
        taxRate: this.taxRate,
        hasAdhocCashFlow: this.hasAdhocCashFlow,
        adhocCashFlowAge1: this.adhocCashFlowAge1,
        adhocCashFlowAge2: this.adhocCashFlowAge2,
        adhocCashFlowAge3: this.adhocCashFlowAge3,
        adhocCashFlow1: this.adhocCashFlow1,
        adhocCashFlow2: this.adhocCashFlow2,
        adhocCashFlow3: this.adhocCashFlow3,
      });

      console.log("update proj 2");
      this.getContributionCashFlowRequestR = new GetContributionCashFlowRequest(
        {
          applyContribution: this.applyContribution,
          contribution: this.contribution,
          contributionFrequency: this.contributionFrequency,
          contributionGrowth: this.contributionGrowth / 100,
          contributionGrowthFrequency: this.contributionGrowthFrequency,
          contributionToLast: this.contributionToLast,
          contributionStartYear: this.contributionStartYear,
        }
      );

      // this.getIncomeCashFlowResponse = getIncome(this.getIncomeCashFlowRequestR);
      /* let incomeResponse = await getIncomeCashFlowRequest(
        this.getIncomeCashFlowRequestR
      );

       */
      console.log("update proj 3");

      let incomeResponse = await additionalGetIncomeCashFlowRequest({
        additionalGetIncomeCashFlowRequests: this.adjustedAdditionalIncome,
      });
      if (incomeResponse) {
        console.log("update proj 4a", this.adjustedAdditionalIncome);
        console.log("update proj 4b", incomeResponse);
      }
      /*
      let contriResponse = await getContribution(
        this.getContributionCashFlowRequestR
      );*/
      let contriResponse = await additionalGetContributionCashFlowRequest({
        additionalGetContributionCashFlowRequests: this.adjustedContributions,
      });

      if (incomeResponse) {
        console.log("update proj 5", contriResponse);
        this.getIncomeCashFlowResponseR = incomeResponse;
        if (contriResponse) {
          this.getContributionCashFlowResponse = contriResponse;
          this.projectionRequest = new GetProjection({
            // wrapper

            raInputsDto: this.raInputsDto,
            laInputsDto: this.laInputsDto,
            //
            adjustForInflation: this.adjustForInflation,
            accounts: this.accounts,
            currentAge: this.currentAge,
            incomeToLastUntilAge: this.incomeToLast,
            getIncomeCashFlowRequest: this.getIncomeCashFlowRequestR,
            getContributionCashFlowRequest: this
              .getContributionCashFlowRequestR,

            /// additional cash ifnlow requests.
            additionalGetIncomeCashFlowRequests: this.adjustedAdditionalIncome,
            additionalGetContributionCashFlowRequests: this
              .adjustedContributions,

            riskProfile: this.riskProfile,
            goalRiskProfile: this.goalRiskProfile,
            incomeCashFlowResponse: incomeResponse,
            contributionCashFlowResponse: contriResponse,
            platformFee: this.platformFee,
            otherCharges: this.otherCharges,
            advisorFee: this.advisorFee,

            moreLikelyZScore: this.moreLikelyZScore,
            lessLikelyZScore: this.lessLikelyZScore,
            showLowestProjectedOutcome: this.showLowestProjectedOutcome,
            isFundAlphaEqualToFees: this.isFundAlphaEqualToFees,
            aaType: this.aaType,
            appearanceSettings: this.appearanceSettings,
            version: "V3",
            goalInfo: new GoalInfo({
              goalName: this.goalName,
              goalDescription: this.goalDescription,
              goalHasTarget: this.goalHasTarget,
              goalTarget: this.goalTarget,
              goalTargetAge: this.goalTargetAge,
              type: this.goalType,
              currency: this.currency,
              wrapperType: this.wrapperType,
            }),
          });
          //this.projectionResponse = calculateProjection(this.projectionRequest);

          const presponse = await getProjections(this.projectionRequest);
          this.projectionResponse = presponse;
          // recalculate goal risk profile
          this.calculateRiskNeed();
          this.loading = false;
          //
        }
      }
    },
    async updateCp() {
      {
        this.loading = true;
        var cp = await getCustomPortfolio({
          id: this.selectedPortfolio.customPortfolioId,
          aaType: this.aaType,
        });
        if (cp) {
          this.customPortfolio = cp.result;

          this.selectedPortfolio = cp.portfolioView;
          this.loading = false;
        }
      }
    },
    async calculateRiskNeed() {
      console.log("calculateRiskNeed 1");
      // this.updated = true;
      this.activePlan = this.projectionRequest;
      console.log("calculateRiskNeed 2");

      let getIncomeCashFlowRequestR = new GetIncomeCashFlowRequest({
        income: this.activePlan.getIncomeCashFlowRequest.income,
        incomeGrowth: this.activePlan.getIncomeCashFlowRequest.incomeGrowth,
        incomeGrowthFrequency: this.activePlan.getIncomeCashFlowRequest
          .incomeGrowthFrequency,
        payoutFrequency: this.activePlan.getIncomeCashFlowRequest
          .payoutFrequency,
        incomeToLast: this.activePlan.getIncomeCashFlowRequest.incomeToLast,
        startYear: this.activePlan.getIncomeCashFlowRequest.startYear,
        currentAge: this.activePlan.getIncomeCashFlowRequest.currentAge,

        taxRate: this.activePlan.getIncomeCashFlowRequest.taxRate,
        hasAdhocCashFlow: this.activePlan.getIncomeCashFlowRequest
          .hasAdhocCashFlow,
        adhocCashFlowAge1: this.activePlan.getIncomeCashFlowRequest
          .adhocCashFlowAge1,
        adhocCashFlowAge2: this.activePlan.getIncomeCashFlowRequest
          .adhocCashFlowAge2,
        adhocCashFlowAge3: this.activePlan.getIncomeCashFlowRequest
          .adhocCashFlowAge3,
        adhocCashFlow1: this.activePlan.getIncomeCashFlowRequest.adhocCashFlow1,
        adhocCashFlow2: this.activePlan.getIncomeCashFlowRequest.adhocCashFlow2,
        adhocCashFlow3: this.activePlan.getIncomeCashFlowRequest.adhocCashFlow3,
      });
      console.log("calculateRiskNeed 3");
      let getContributionCashFlowRequestR = new GetContributionCashFlowRequest({
        applyContribution: this.activePlan.getContributionCashFlowRequest
          .applyContribution,
        contribution: this.activePlan.getContributionCashFlowRequest
          .contribution,
        contributionFrequency: this.activePlan.getContributionCashFlowRequest
          .contributionFrequency,
        contributionGrowth:
          this.activePlan.getContributionCashFlowRequest.contributionGrowth /
          100,
        contributionGrowthFrequency: this.activePlan
          .getContributionCashFlowRequest.contributionGrowthFrequency,
        contributionToLast: this.activePlan.getContributionCashFlowRequest
          .contributionToLast,
        contributionStartYear: this.activePlan.getContributionCashFlowRequest
          .contributionStartYear,
      });
      console.log("calculateRiskNeed 4");
      const response = await getRiskNeed({
        lumpSum: this.activePlan.accounts[0].accountMarketValue,
        additionalGetIncomeCashFlowRequests: this.adjustedAdditionalIncome,
        additionalGetContributionCashFlowRequests: this.adjustedContributions,
        getIncomeCashFlowRequest: getIncomeCashFlowRequestR,
        getContributionCashFlowRequest: getContributionCashFlowRequestR,
        goalInfo: this.activePlan.goalInfo,
      });
      if (response) {
        console.log("calculateRiskNeed 5");
        this.getRiskNeedResponse = response;
        this.goalRiskProfile.getRiskNeedResponse = response;
        this.projectionRequest.goalRiskProfile.getRiskNeedResponse = this.goalRiskProfile.getRiskNeedResponse;
        this.calculateGoalRiskProfile();

        console.log("calculateRiskNeed 6");
      }
    },
    async calculateGoalRiskProfile() {
      //console.log("calculateGoalRiskProfile");
      //this.updated = true;

      if (this.goalRiskProfile) {
        const response = await getGoalRiskProfile({
          currency: this.currency,
          getRiskToleranceResponse: this.goalRiskProfile
            .getRiskToleranceResponse,
          getRiskAbilityResponse: this.goalRiskProfile.getRiskAbilityResponse,
          getRiskNeedResponse: this.goalRiskProfile.getRiskNeedResponse,
        });
        if (response) {
          this.goalRiskProfile.getGoalRiskProfileResponse = response;
          this.projectionRequest.goalRiskProfile.getGoalRiskProfileResponse = response;
          this.riskProfile = this.goalRiskProfile.getGoalRiskProfileResponse.riskProfileObject;

          var response12 = await getPortfoliosGivenRisk({
            riskProfileId: this.goalRiskProfile.getGoalRiskProfileResponse
              .riskProfileId,
          });

          this.riskPortfolios = response12.result;
        }
      }
    },

    selectChange(event) {
      this.updated = true;
      this.selected = event;
      this.updateProjection();
    },
    ageChange() {
      this.updated = true;
      this.updateProjection();
    },
    async handleReasonChanged(event) {
      this.updated = true;
    },
    async riskChange(event) {
      this.updated = true;
      this.accounts = event.accounts;
      //  this.riskTolerance = event.riskTolerance;
      //  this.riskCapacity = event.riskCapacity;
      //  this.riskProfile = event.riskProfile;

      if (this.tabRight != 8) {
        this.selectedPortfolio = event.selectedPortfolio;
      } else {
        const response = await getCustomPortfolio({
          currency: this.currency,
          id: event.selectedPortfolio.customPortfolioId,
          aaType: this.aaType,
        });

        if (response) {
          this.selectedPortfolio = response.portfolioView;
          /*this.selectedPortfolio.positions = response.portfolioView.positions;

          this.selectedPortfolio.customPortfolioId = response.result.id;
          this.selectedPortfolio.yearlyPerformances =
            response.portfolioView.yearlyPerformances;
          this.selectedPortfolio.cumulativePerformances =
            response.portfolioView.cumulativePerformances;
          this.selectedPortfolio.currentAssetAllocation =
            response.portfolioView.currentAssetAllocation;
          console.log("this.selectedPortfolio - ", this.selectedPortfolio);*/
        }
      }
      //  this.riskPortfolios = event.riskPortfolios;
      //  this.goalRiskProfile = event.goalRiskProfile;
      this.updateProjection();
    },
    feeChange(event) {
      console.log("feeChange");
      this.updated = true;
      this.otherCharges = event.otherCharges;
      this.platformFee = event.platformFee;
      this.advisorFee = event.advisorFee;

      this.updateProjection();
    },
    handleZScoreChanged(event) {
      console.log("handleZScoreChanged", event);
      this.updated = true;
      this.moreLikelyZScore = event.moreLikelyZScore;
      this.lessLikelyZScore = event.lessLikelyZScore;
      this.showLowestProjectedOutcome = event.showLowestProjectedOutcome;
      this.isFundAlphaEqualToFees = event.isFundAlphaEqualToFees;

      this.aaType = event.aaType;
      //this.isFundAlphaEqualToFees = event.isFundAlphaEqualToFees;
      this.updateProjection();
      this.updateCp();
    },
    goalChange(event) {
      this.updated = true;
      this.goalName = event.goalName;
      this.goalDescription = event.goalDescription;
      this.goalHasTarget = event.goalHasTarget;
      this.goalTarget = event.goalTarget;
      this.goalTargetAge = event.goalTargetAge;
      this.wrapperType = event.wrapperType;

      this.updateProjection();
    },
    selectDefault() {
      this.selected = this.accounts[0];
    },
  },
  async mounted() {
    // load client details

    this.clientId = this.$route.params.clientid;
    if (this.clientId != 0) {
      const clientResponse = await getClientV2({ id: this.clientId });
      if (clientResponse) {
        this.clientFirstName = clientResponse.result.firstName;
        this.clientLastName = clientResponse.result.lastName;
        this.email = clientResponse.result.email;
      }
    }
    this.init();
  },
};
</script>

<style scoped>
.projection-container {
  font-family: "Poppins", sans-serif;
  position: relative;

  z-index: 1;
  padding: 5em 0 0 0;
  margin: 0;
}

.projection-container .proj {
  position: absolute;
  z-index: -1;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: url("https://assets.website-files.com/5c6eb35188c954830ec0365d/5c817444f2a0f7e7f938ae36_yacht-dtp.jpg")
    center center;
  background-size: cover;
  opacity: 0.7;
  width: 100%;
  height: 100%;
}

.projection-container .proj-menu {
  position: absolute;
  z-index: -1;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  background-size: cover;
  opacity: 0.65;
  width: 100%;
  height: 65px;
}

.projection-container .projheader {
  font-family: "Poppins", sans-serif;
  color: rgba(46, 44, 44, 0.719);
  font-size: 2em;
  opacity: 1;
}

#bluebg {
  background: rgb(2, 0, 36);
  background: linear-gradient(
    90deg,
    rgba(2, 0, 36, 1) 0%,
    rgba(142, 189, 212, 1) 0%,
    rgba(0, 106, 166, 1) 100%
  );
}

#tanbg {
  background: rgb(2, 0, 36);
  background: linear-gradient(
    90deg,
    rgba(2, 0, 36, 1) 0%,
    rgb(182, 212, 142) 0%,
    rgb(147, 175, 122) 100%
  );
}

#coffeebg {
  background: rgb(2, 0, 36);
  background: linear-gradient(
    90deg,
    rgba(2, 0, 36, 1) 0%,
    rgba(142, 189, 212, 1) 0%,
    rgba(0, 106, 166, 1) 100%
  );
}
</style>
